enum StvAnrede {
    HERR = "HERR", FRAU = "FRAU"
}

export default StvAnrede;